module.exports = __webpack_public_path__ + "_assets/img/title.c0c22837.svg";